<template lang="pug">
.k-kintell-card-skill-list.d-flex.justify-center.flex-wrap
  k-chip(
    v-for="(skill, index) in skills"
    :key="index"
    color="brand-light-aqua-50"
    text-color="brand-dark-aqua"
  ).no-pointer.ma-1 {{ skill.name ? skill.name : skill }}
</template>

<script>
export default {
  props: {
    skills: {
      type: Array,
      required: true
    }
  },
}
</script>
